import { BaseDto } from "@models/base/baseDto.model"

export class UpdateCasosUsoRequest extends BaseDto{
  public path!:string
  public icon!:string
  public idMenu!:number
}
